import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { MakingTecaPost, MakingTecaPostData } from '../../shared/interface';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-making-teca-post',
  templateUrl: './making-teca-post.component.html',
  styleUrl: './making-teca-post.component.css'
})
export class MakingTecaPostComponent implements OnInit {

  constructor(private apiService: ApiService, private route: ActivatedRoute, private router: Router) { }

  posts: MakingTecaPost[] = []
  post?: MakingTecaPost;
  post_data: MakingTecaPostData[] = [];  

  ngOnInit(): void {

    // Recupero l'id dall'url
    this.route.params.subscribe(params => {

      let id = params['id'];

      // Recupero i dati del post        
      this.apiService.getMakingTecaPost(id).subscribe({
        next: (data) => this.post = data,
        error: (err) =>  this.router.navigate(['/']),
        complete: () => {
          // Recupero le informazioni legate al post (immagini e testi)
          this.apiService.getMakingTecaPostData(id).subscribe({
            next: (data) => this.post_data = [...data],
            error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
            complete: () => {
              // Recupero gli altri post restanti              
              this.apiService.getMakingTecaPosts().subscribe({
                next: (data) => this.posts = [...data.filter(post => post.id !== this.post?.id)],
                error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
              })
            }
          })
        }
      })

    })

  }

  onPost(id: number) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/making-teca/' + id]);
    });
  }

}
